/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {completeScenarioDirect} from '../api'

export const useMutationCompleteScenarioDirect = createReactQueryMutationHook('completeScenarioDirect', completeScenarioDirect)
